module.exports = __webpack_public_path__ + "static/media/linkedin.c1eb2740.svg";